import { toast } from "react-toastify";
import { getUserSettings } from "../../../configs/menuProfile";
import { AuthClient } from "../../../api/auth";
import { logOff } from "../../../api/api-client";

export const auth = {
  state: {
    user: {
      loading: false
    },
    menus: [],
    envSettings: {},
    loading: false
  },
  reducers: {
    setUser(state, payload) {
      return {
        ...state,
        user: {
          ...state.user,
          ...payload
        }
      };
    },
    menus(state, payload) {
      return {
        ...state,
        menus: [...payload]
      };
    },
    envSettings(state, payload) {
      return {
        ...state,
        envSettings: {
          ...payload
        }
      };
    },
    loading(state, payload) {
      return {
        ...state,
        loading: payload
      };
    },
    clearStore() {
      return {};
    }
  },
  effects: (dispatch) => ({
    async getSettingsAsync(access_code = null) {
      this.loading({ loading: true });
      try {
        let data = null;
        if (access_code === null) {
          data = window.localStorage.getItem('userData');
          if (data) {
            data = JSON.parse(data);
          }
        } else {
          const res = await AuthClient.getSetting(access_code);
          data = res.data;
          window.localStorage.setItem('userData', JSON.stringify(data));
        }
        this.menus(getUserSettings(data.user.mainGroup, data.user.groups));
        this.setUser(data.user);
        this.envSettings(data.enviromentSetings);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado!");
        logOff();
      }
    },
    async postAgreementAsync(payload) {
      this.loading({ loading: true });
      try {
        const res = await AuthClient.postAgreement(payload.mode, payload.checked);
        const { data } = res;
        let userLocalStoraged = JSON.parse(localStorage.getItem('userData'));

        this.setUser(data.user);

        if (userLocalStoraged) {
          userLocalStoraged.user.hasAcceptedTerms = payload.checked;
          localStorage.setItem('userData', JSON.stringify(userLocalStoraged));
        }

        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });

        await toast.error('Algo deu errado :( !', {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  })
};
